import Blog from "../../components/blogs/blog";
import styles from "./blogs.module.css";

const Blogs = () => {
    return ( 
        <div>
            <Blog></Blog>
        </div>
    );
}
 
export default Blogs;